import { SupportedLanguages } from 'src/modules/locales/types';

export enum ConfigKeys {
  HideCountryField = 'hideCountryField',
  BlockCountryField = 'blockCountryField',
  HideCountryUKDropdown = 'hideCountryUKDropdown',
  HideDropAndWins = 'hdeDropAndWins'
}

export type Config = Record<ConfigKeys, boolean>;

export interface LanguageConfig {
  language: SupportedLanguages;
  clearInterseptors?: () => void;
  config: Config;
}

export type MapKey =
  | 'default'
  | 'authorized_uk'
  | 'uk_no_referral'
  | 'uk_with_referral'
  | 'non_uk_with_referral';

export type ConfigMap = Map<MapKey, { config: LanguageConfig['config'] }>;
